import { Box } from "@mui/material";
import { useOutletContext, useParams } from "react-router";
import { useSignedInUser } from "@platform/user/client";

import { WorkbenchContext } from "../types";

import NewDocumentInformation from "./newDocumentInformation";
import RFPBrokerageCard from "./rfpBrokerageCard";
import { RfpCarrierContactsCard } from "./rfpCarrierContactsCard";
import RFPCarriersCard from "./rfpCarriersCard";
import RFPClientCard from "./rfpClientCard";
import RFPCoveragesCard from "./rfpCoveragesCard";
import RFPDetailsCard from "./rfpDetailsCard";
import RfpDocumentsCard from "./rfpDocumentsCard";
import WorkbenchBuild from "./workbenchBuild";

type Props = Pick<WorkbenchContext, "refetchRpfDetails">;

function WorkbenchRFPDetails({ refetchRpfDetails }: Props): React.JSX.Element {
  const { id: rfpId } = useParams();
  const { isBrokerOrAgent } = useSignedInUser();
  const workbenchContext = useOutletContext<WorkbenchContext>();
  const commonCards = (
    <>
      <RFPDetailsCard rfpId={rfpId} refetchRpfDetails={refetchRpfDetails} />
      <RFPClientCard rfpId={rfpId} refetchRpfDetails={refetchRpfDetails} />
      <RFPBrokerageCard rfpId={rfpId} refetchRpfDetails={refetchRpfDetails} />
      {!isBrokerOrAgent ? (
        <RfpCarrierContactsCard rfpId={rfpId} />
      ) : (
        <RFPCarriersCard rfpId={rfpId} refetchRpfDetails={refetchRpfDetails} />
      )}
    </>
  );

  if (isBrokerOrAgent) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {commonCards}
        <RfpDocumentsCard
          rfpId={rfpId}
          onMarketingPresentationUploaded={refetchRpfDetails}
        />
        <NewDocumentInformation
          files={workbenchContext.state?.data?.rfpFiles}
          coverages={workbenchContext.state?.data?.coverage}
          additionalDocs={workbenchContext.state?.additionalDocuments}
        />
        <WorkbenchBuild />
      </Box>
    );
  }
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      {commonCards}
      <RFPCoveragesCard rfpId={rfpId} />
    </Box>
  );
}

export default WorkbenchRFPDetails;
